export default __webpack_public_path__ + "static/media/selected-hospital1.adb3deac.png";